'use client';

import { uniq } from 'lodash-es';
import { parseAsString, useQueryStates } from 'nuqs';
import { useEffect } from 'react';

import { CONTENT_TYPE, EVENT_ACTION, EVENT_TYPE, PAGE_ID } from '~/apis/log/constant';
import { ProductMercariDetailModel } from '~/apis/pms';
import { useAppContext } from '~/contexts/AppContext/AppContext';

import { useSendLog } from '~/hooks';

type Props = {
  data: ProductMercariDetailModel;
};

export const LogProductViewContent = ({ data }: Props) => {
  const sendLog = useSendLog();
  const { viewedProductIds, setViewedProductIds } = useAppContext();

  const [query] = useQueryStates({
    ref_page: parseAsString,
    ref_term: parseAsString,
    ref_position: parseAsString,
  });
  // TODO: 상품 상세는 새 웹뷰로 열림 + 상품상세 -> 다른상품 이동시 context가 유지되는 것을 이용해
  // appContext 를 사용하도록 개발하였으나, history back event 를 캐치하는 방식으로 개선되어야 함.

  useEffect(() => {
    const isViewdProduct = viewedProductIds?.includes(data.product.pid.toString());

    if (!isViewdProduct) {
      sendLog({
        event_type: EVENT_TYPE.VIEW,
        event_action: EVENT_ACTION.VIEW_CONTENT,
        page_id: PAGE_ID.PRODUCT,
        content_id: data.product.pid.toString(),
        content_type: CONTENT_TYPE.MERCARI,
        content_owner: data.shop.mercariUid?.toString(),
        content_status: data.product.saleStatus,
        ...(query?.ref_term && { ref_term: query.ref_term }),
        ...(query?.ref_position && { content_position: query.ref_position }),
      });
    }

    const newViewedProductIds = uniq([...viewedProductIds, data.product.pid.toString()]);
    setViewedProductIds?.(newViewedProductIds);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return null;
};
